import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import Container from '../../layout/container/container';
import Spacing from '../../layout/spacing/spacing';
import Services from '../../services/services';
import ServicesMobile from '../../services/services-mobile';

const ServicesBlock = ({ paddingTop, paddingBottom, background, ...props }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1000);
    };

    // Check screen size initially and on every window resize
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    // Cleanup the event listener when the component unmounts
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <Container gutters bg={background}>
      <Spacing pt={paddingTop} pb={paddingBottom}>
        {isMobile ? <ServicesMobile {...props} /> : <Services {...props} />}
      </Spacing>
    </Container>
  );
};

export default ServicesBlock;

export const query = graphql`
  fragment ServicesBlock on DatoCmsServicesBlock {
    id: originalId
    heading
    headingSize
    text
    side
    background
    paddingBottom
    paddingTop
    anchor
    services {
      title
      paragraphText
    }
    __typename
  }
`;
